import React from "react";
import { Link } from "react-router-dom";
import useWindowSize from '../../../useWindowSize';
const currentDomain = process.env.REACT_APP_SUB_DOMAIN;
export const SHSRMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  return (
    <div className="department-menu">
      <div className="container">
        <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
            Menu
          <span className="fad fa-list-ul" onClick={() => { setInternalMenuOpen(!internalMenuOpen); }}></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={`/${currentDomain}/`}>Home</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/about-us`}>About Us</Link>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Admissions</Link>
              <ul>
                <li>
                  <Link
                    to={`/${currentDomain}/environmental-occupational-health-safety`}
                  >
                    Courses Offered
                  </Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/faculty`}>Faculty</Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/health-conference`}>
                    Health Conference
                  </Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/gallery`}>Gallery</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to={`/${currentDomain}/examinations`}>Examinations</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/contact-us`}>Contact Us</Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const SREEMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  return (
    <div className="department-menu">
      <div className="container">
      <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
            Menu
          <span className="fad fa-list-ul" onClick={() => { setInternalMenuOpen(!internalMenuOpen); }}></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={`/${currentDomain}/`}>Home</Link>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Admissions-M.Tech</Link>
              <ul>
                <li>
                  <Link to={`/${currentDomain}/about-course`}>About Course</Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/course-structure`}>
                    Course Structure
                  </Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/infra-structure`}>
                    Infra Structure
                  </Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/syllabus`}>Syllabus</Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/eligibility`}>Eligibility</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to={`/${currentDomain}/faculty`}>Faculty</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/research-publications`}>
                Research & Publications
              </Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/university-industry-interaction`}>
                Industry Interaction
              </Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/placements`}>Placements</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/gallery`}>Gallery</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/contact-us`}>Contact Us</Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const SOAMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  return (
    <div className="department-menu">
      <div className="container">
      <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
            Menu
          <span className="fad fa-list-ul" onClick={() => { setInternalMenuOpen(!internalMenuOpen); }}></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={`/${currentDomain}/`}>Home</Link>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Course Details</Link>
              <ul>
                <li>
                  <Link to={`/${currentDomain}/about-course`}>About Course</Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/eligibility`}>Eligibility</Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/syllabus`}>Syllabus</Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/infra-structure`}>
                    Infra Structure
                  </Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/bos`}>BOS</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to={`/${currentDomain}/faculty`}>Faculty</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/research-publications`}>
                Research Publications
              </Link>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Department Activities</Link>
              <ul>
                <li>
                  <Link to={`/${currentDomain}/mous-signed`}>MOUs signed</Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/internship-opportunities`}>
                    Internship Opportunities
                  </Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/campus-placements`}>
                    Campus Placements
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to={`/${currentDomain}/gallery`}>Gallery</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/contact-us`}>Contact Us</Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const SSITMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  return (
    <div className="department-menu">
      <div className="container">
      <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
            Menu
          <span className="fad fa-list-ul" onClick={() => { setInternalMenuOpen(!internalMenuOpen); }}></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={`/${currentDomain}/`}>Home</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/about-us`}>About Us</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/vision-and-mission`}>
                Vision & Mission
              </Link>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Academics</Link>
              <ul>
                <li>
                  <Link to={`/${currentDomain}/about-course`}>About Course</Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/course-structure`}>
                    Course Structure
                  </Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/eligibility`}>Eligibility</Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/syllabus`}>Syllabus</Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/academic-calendar`}>
                    Academic Calendar
                  </Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/timetables`}>Timetables</Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/case-study-focus`}>
                    Case Study Focus
                  </Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/ssit-advantage`}>
                    SSIT Advantage
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to={`/${currentDomain}/infra-structure`}>Infrastructure</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/faculty`}>Faculty</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/bos`}>BOS</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/research-scholars`}>
                Research Scholars
              </Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/research-publications`}>
                Publications
              </Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const SNTMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  return (
    <div className="department-menu">
      <div className="container">
      <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
            Menu
          <span className="fad fa-list-ul" onClick={() => { setInternalMenuOpen(!internalMenuOpen); }}></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={`/${currentDomain}/`}>Home</Link>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Admissions</Link>
              <ul>
                <li>
                  <Link to={`/${currentDomain}/about-course`}>About Course</Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/bos`}>BOS</Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/eligibility`}>Eligibility</Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/course-structure`}>
                    Course Structure
                  </Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/syllabus`}>Syllabus</Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/academic-calendar`}>
                    Academic calendars
                  </Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/timetables`}>Timetables</Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/infra-structure`}>
                    Infrastructure
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to={`/${currentDomain}/faculty`}>Faculty</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/industry-interaction`}>
                Industry Interaction
              </Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/research-publications`}>
                Research & Publications
              </Link>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Department Activities</Link>
              <ul>
                <li>
                  <Link to={`/${currentDomain}/project-opportunities`}>
                    Project Opportunities
                  </Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/campus-placements`}>
                    Campus Placements
                  </Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/student-activities`}>
                    Student Activities
                  </Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/sports-activity`}>
                    Sports Activity
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to={`/${currentDomain}/achievements`}>Achievements</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/gallery`}>Gallery</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/contact-us`}>Conact Us</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/notificationstenders`}>
                Notifications/Tenders
              </Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const SMSMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  return (
    <div className="department-menu">
      <div className="container">
      <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
            Menu
          <span className="fad fa-list-ul" onClick={() => { setInternalMenuOpen(!internalMenuOpen); }}></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={`/${currentDomain}/`}>Home</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/programs`}>Programs</Link>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Admissions-MBA</Link>
              <ul>
                <li>
                  <Link to={`/${currentDomain}/about-course`}>About Course</Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/course-structure`}>
                    Course Structure
                  </Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/eligibility`}>Eligibility</Link>
                </li>

                <li>
                  <Link to={`/${currentDomain}/syllabus`}>Syllabus</Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/infra-structure`}>
                    Infrastructure
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to={`/${currentDomain}/research-publications`}>
                Research & Publications
              </Link>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Events</Link>

              <ul>
                <li>
                  <Link to={`/${currentDomain}/forthcoming-events`}>
                    Forthcoming Events
                  </Link>
                </li>
                <li>
                  <Link to={`/${currentDomain}/past-events`}>Past Events</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to={`/${currentDomain}/faculty`}>Faculty</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/notifications`}>Notifications</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/placements`}>Placements</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/achivements`}>Achievements</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/alumni`}>Alumni</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/contact-us`}>Contact Us</Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};
